<!-- Titolo, contenuto e fascia delle azioni sono figli DIRETTI della superficie
     (niente <div> di raggruppamento): e' la condizione perche' la veste
     .izy-confirm-dialog-panel tenga la fascia panna a filo del bordo
     inferiore. -->
<h2 mat-dialog-title>Carica documento</h2>

<mat-dialog-content>
  <p class="izy-confirm-message">Stai per caricare il seguente file:</p>

  <!-- Il file in un riquadro a se', nella grammatica BEIZY: superficie bianca
       bordata nera 2px, angolo basso-sinistra vivo e icona in petrol, come
       l'esito dell'import XML. -->
  <div class="izy-file-box izy-sharp-bl">
    <mat-icon class="izy-file-icon" fontSet="material-icons-outlined">
      insert_drive_file
    </mat-icon>
    <div class="izy-file-info">
      <span class="izy-file-name">{{ data.fileName }}</span>
      <span class="izy-file-meta">{{ data.fileSize }}</span>
    </div>
  </div>

  <p class="izy-upload-question">
    Il nostro team potrà visualizzarlo. Confermi?
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="izy-dialog-actions">
  <button
    mat-stroked-button
    type="button"
    mat-dialog-close
    class="izy-button-ghost custom-button-border">
    <mat-icon>arrow_back</mat-icon>
    Indietro
  </button>

  <button
    mat-raised-button
    matButton="filled"
    type="button"
    class="ms-2 izy-button-primary custom-button-border"
    (click)="confirm()">
    <mat-icon>check</mat-icon>
    Confermo
  </button>
</mat-dialog-actions>
